import { render, staticRenderFns } from "./DetalleFactura.vue?vue&type=template&id=6792058c&"
import script from "./DetalleFactura.vue?vue&type=script&lang=js&"
export * from "./DetalleFactura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports